import { ResetPasswordRequest } from '@provider-portal/common/api/gen/DeliveryProviderNoAuthApi';
import { ActionType, createAsyncAction } from 'typesafe-actions';

export const requestRequestResetPasswordAsyncAction = createAsyncAction(
  '@password/REQUEST_RESET_PASSWORD',
  '@password/REQUEST_RESET_PASSWORD_SUCCESS',
  '@password/REQUEST_RESET_PASSWORD_FAILURE',
)<string, void, Error>();

export const requestSetNewPasswordAsyncAction = createAsyncAction(
  '@password/SET_NEW_PASSWORD',
  '@password/SET_NEW_PASSWORD_SUCCESS',
  '@password/SET_NEW_PASSWORD_FAILURE',
)<ResetPasswordRequest, void, Error>();

export type PasswordActions =
  | ActionType<typeof requestRequestResetPasswordAsyncAction>
  | ActionType<typeof requestSetNewPasswordAsyncAction>;
